import { AxiosResponse } from "axios";
import RequestUtilitario, { BasicQueryType } from "../../../../Utils/RequisicaoUtilitario";
import Pagamento from "../../../../Models/Domain/FInanceiro/Titulo/Pagamento";
import { useQuery } from "@tanstack/react-query";
import { Axios } from "../../../Axios";

export function useBuscarPorToken ({
    identificador,
    token,
    ...rest
}:BasicQueryType<AxiosResponse<Pagamento|null>, {
    identificador:number,
    token:string
}>) {    
    const queryString = new URLSearchParams({
        identificador,
        token
    } as any).toString();

    return useQuery({
        ...rest,
        queryKey : [`Domain.Financeiro.Titulo.Pagamento.Buscar?${queryString}`],
        queryFn : () => Axios.get<Pagamento|null>(`domain/financeiro/titulo/pagamento?${queryString}`).catch(ex => {
            throw ex.response.data;
        })
    });
}

export default {
    useBuscarPorToken
}